module.exports = __webpack_public_path__ + "img/artist-back-view.656c747d.jpg";